import { render, staticRenderFns } from "./singleWrapper.vue?vue&type=template&id=07425cc8"
import script from "./singleWrapper.vue?vue&type=script&lang=js"
export * from "./singleWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports